<template>
  <div class="container login">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="logo">
          <img src="@/csmworkflow/img/logo.svg"/>
        </div>
        <div class="card card-signin my-5">
          <div class="card-body">
            <h5 class="card-title text-center">Reset Password</h5>
            <div class="alert alert-danger" v-show="error">{{ error }}</div>
            <div class="alert alert-success" v-show="success">{{ success }}</div>
            <form @submit.prevent="sendResetPasswordEmail" class="form-signin">
              <div class="form-label-group">
                <input
                  type="email"
                  id="inputEmail"
                  class="form-control"
                  v-model="email"
                  placeholder="Email address"
                  required
                  autofocus
                />
                <label for="inputEmail">Email address</label>
              </div>
              <button class="btn btn-lg btn-primary btn-block text-uppercase" type="submit">Send</button>
              <hr />
              <router-link
                class="btn btn-lg btn-success btn-block text-uppercase"
                to="/login"
              >Login</router-link>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ForgotPassword",
  data() {
    return {
      email: "",
      error: "",
      success: ""
    };
  },
  methods: {
    sendResetPasswordEmail() {
      let email = this.email,
        password = this.password;
      this.$store
        .dispatch("sendResetPasswordEmail", { email })
        .then((response) => {
          if(response.data.success) {
            this.success = response.data.msg;
          } else {
            this.error = response.data.msg;
          }
        })
        .catch(err => {
          this.error = err;
        });
    }
  }
};
</script>